<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="大会议程列表" name="1">
      <ProcessAdd :updataID='updataID'></ProcessAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * lx
 * 大会议程修改
 */
import ProcessAdd from '../../../../static/form/ProcessAdd.vue'
export default {
  components: {
    ProcessAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Processgl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/ProcessUpdate.vue